import { render, staticRenderFns } from "./UserSettingsContactDelete.vue?vue&type=template&id=188b793f&"
import script from "./UserSettingsContactDelete.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContactDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188b793f')) {
      api.createRecord('188b793f', component.options)
    } else {
      api.reload('188b793f', component.options)
    }
    module.hot.accept("./UserSettingsContactDelete.vue?vue&type=template&id=188b793f&", function () {
      api.rerender('188b793f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsContact/UserSettingsContactDelete.vue"
export default component.exports